
export const getKey = (searchString, searchParams) => {
    for (var key of searchParams.keys()) {
        if(searchString.toLowerCase() === key.toLowerCase()){
            return key;
        }
    }
    return searchString;
}